<template>
  <div>
    <v-row class="white">
      <v-col class="display-1 ma-3">DASHBOARD</v-col>
    </v-row>
    <v-container class="background-gray pa-1 pl-5 text-center">
      <v-row>
        <v-col cols="12" lg="6" class="dashboard__last-updated">
          <v-select
            class="pa-0 ma-0"
            v-model="filterDateStatus"
            :items="filters"
            hide-details
            @change="changeFilterDate"
          ></v-select>
          <div v-if="showDatesSelected" class="d-flex align-center justify-end">
            {{ datesSelected.join(" ~ ") }}
            <v-btn x-small class="ma-0 ml-2" @click="showCalendar = true"
              >cambiar</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row wrap class="mt-2" justify="center">
        <v-col cols="12" sm="6" class="pl-10 pr-10">
          <v-card class="display-3 accent--text pt-7 pb-7 elevation-0">
            <v-progress-circular
              v-if="!dataloaded"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <span v-if="dataloaded">{{ pendingOrders | thousands }}</span>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="font-extralight mt-1 pa-0"
          >ORDENES PENDIENTES</v-col
        >
      </v-row>
    </v-container>
    <v-container class="pl-5 pr-5 text-center">
      <v-row justify="center" align="center">
        <v-col cols="10" class="white pr-0">
          <v-autocomplete
            clearable
            class="font-weight-light"
            label="Buscar Orden"
            type="text"
            autocomplete="off"
            @keyup.enter="searchOrder(id)"
            :items="searchDataKeys"
            hide-details
            outlined
            v-model="id"
            :loading="loadingSearch"
          ></v-autocomplete>
        </v-col>
        <v-col cols="2" class="white pt-7 pb-7">
          <v-icon dark color="accent" @click="searchOrder(id)"
            >fas fa-search</v-icon
          >
        </v-col>
        <v-col cols="12" class="white d-flex pt-0">
          <v-checkbox
            hide-details
            class="ma-0 mr-3"
            v-model="orderCheckbox"
            label="Ordenes"
          ></v-checkbox>
          <v-checkbox
            hide-details
            class="ma-0 mr-3"
            v-model="saleCheckbox"
            label="Pedidos"
          ></v-checkbox>
          <v-checkbox
            hide-details
            class="ma-0"
            v-model="serieCheckbox"
            label="Serie de equipo"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="background-gray text-center">
      <v-row>
        <v-col cols="12" class="subheading text-center orders-title"
          >Ordenes en proceso</v-col
        >
        <v-col cols="12" class="body-1 pl-5 pr-5 text-center font-weight-light"
          >Detalle de Ordenes pendientes a realizar</v-col
        >
        <v-col
          cols="12"
          lg="6"
          class="mt-2 pl-5 pt-0 pr-5 pb-0"
          v-for="(event, keyvalue) in prosicEvents"
          :key="keyvalue"
          @click="goToOrdersByType(event.value)"
        >
          <v-card class="elevation-0" link>
            <v-container grid-list-md class="py-0 text-center">
              <v-row>
                <v-col cols="9" class="headline text-left">{{
                  event.title
                }}</v-col>
                <v-progress-circular
                  v-if="!dataloaded"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <v-col
                  cols="3"
                  v-if="dataloaded"
                  class="headline accent--text text-right"
                  text-right
                  >{{ event.counter | thousands }}</v-col
                >
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          class="mt-2 pl-5 pt-0 pr-5 pb-0"
          @click="goToAnalytics()"
        >
          <v-card class="elevation-0" dark link>
            <v-container class="text-center headline py-2">
              VER REPORTES
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" class="mt-2 pl-5 pt-0 pr-5 pb-0">
          <v-card class="elevation-0" dark link to="/history">
            <v-container class="text-center headline py-2">
              VER HISTÓRICO
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="white pl-10 pr-10 d-none">
      <v-row align="center" justify="center">
        <v-col cols="12" lg="6">
          <v-btn
            block
            color="accent"
            class="black--text elevation-0"
            @click="navigateToOrders"
            >Ver todos las ordenes</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showCalendar" max-width="300" persistent>
      <v-card>
        <div class="d-flex justify-end">
          <v-icon @click="closeCalendar" class="ml-2 mt-1">close</v-icon>
        </div>
        <v-container>
          <v-date-picker
            v-model="datesSelected"
            multiple
            :disabled="datesSelected.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelected.length < 2"
              @click="searchByDatesCompleted"
              >Aceptar</v-btn
            >
            <v-btn color="error" @click="resetDates">Borrar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessage } from "@/services/MessageService";
import { shortDateStringFilter, thousandsNumberFilter } from "@/filters";
import { database } from "@/config/firebase";
import moment from "moment";
export default {
  data() {
    return {
      lastUpdated: new Date(),
      id: null,
      loadingSearch: true,
      orderCheckbox: true,
      saleCheckbox: false,
      serieCheckbox: false,
      analyticsRef: null,
      dataloaded: false,
      pendingOrders: 0,
      prosicEvents: {
        delivery: {
          title: "ENTREGAS",
          value: "delivery",
          counter: 0
        },
        maintenance: {
          title: "MANTENIMIENTO",
          value: "maintenance",
          counter: 0
        },
        recollection: {
          title: "RECOLECCIÓN",
          value: "recollection",
          counter: 0
        },
        relocation: {
          title: "REUBICACIÓN",
          value: "relocation",
          counter: 0
        },
        rentedService: {
          title: "RENTADO SERVICIO",
          value: "rented-service",
          counter: 0
        },
        transfer: {
          title: "TRASPASOS",
          value: "transfers",
          counter: 0
        }
      },
      filters: ["Hoy", "Este mes", "Rango de fechas"],
      filterDateStatus: "Este mes",
      showCalendar: false,
      showDatesSelected: false,
      datesSelected: []
    };
  },
  beforeMount() {
    this.getAccesSections(this.userAccess);
  },
  mounted() {
    try {
      const startAt = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      const endAt = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
      this.getDataSearch();
      this.getDashboardCounters(startAt, endAt);
    } catch (error) {
      console.log(error);
      errorMessage("No fue posible obtener la información en este momento");
    }
  },
  computed: {
    ...mapState("dashboard", [
      "totalTransfers",
      "deliveryPendingOrders",
      "searchDataKeys"
    ]),
    ...mapState("user", ["userAccess"])
  },
  watch: {
    orderCheckbox(newValue) {
      if (newValue) {
        this.saleCheckbox = false;
        this.serieCheckbox = false;
        this.getDataSearch();
      }
    },
    saleCheckbox(newValue) {
      if (newValue) {
        this.orderCheckbox = false;
        this.serieCheckbox = false;
        this.getDataSearch();
      }
    },
    serieCheckbox(newValue) {
      if (newValue) {
        this.saleCheckbox = false;
        this.orderCheckbox = false;
        this.getDataSearch();
      }
    }
  },
  filters: {
    shortDate: shortDateStringFilter,
    thousands: thousandsNumberFilter
  },
  beforeDestroy() {
    // :: Detach databaseRef listener
    this.analyticsRef.off("value");
    this.analyticsRef = null;
  },
  methods: {
    ...mapActions("dashboard", [
      "getAccesSections",
      "getDataSearchOrders",
      "getDataSearchSeries"
    ]),
    async getDashboardCounters(startAt, endAt) {
      try {
        this.dataloaded = false;
        this.analyticsRef = await database("analytics")
          .child("checklistStatus")
          .orderByChild("date")
          .startAt(startAt)
          .endAt(endAt);
        this.analyticsRef.on("value", snapshot => {
          if (snapshot.exists()) {
            const generalData = snapshot.val();
            if (generalData) {
              this.prosicEvents.delivery.counter = this.filterStatusChecklist(
                generalData,
                "delivery"
              );
              this.prosicEvents.maintenance.counter = this.filterStatusChecklist(
                generalData,
                "maintenance"
              );
              this.prosicEvents.recollection.counter = this.filterStatusChecklist(
                generalData,
                "recollection"
              );
              this.prosicEvents.relocation.counter = this.filterStatusChecklist(
                generalData,
                "relocation"
              );
              this.prosicEvents.rentedService.counter = this.filterStatusChecklist(
                generalData,
                "rented-service"
              );
              this.pendingOrders = Object.values(generalData).length;
            }
            this.dataloaded = true;
          } else {
            this.dataloaded = true;
          }
        });
      } catch (error) {
        this.dataloaded = true;
        errorMessage(
          "Ha ocurrido un error inesperado al consultar los analiticos"
        );
      }
    },
    async getDataSearch() {
      if (this.saleCheckbox) await this.getDataSearchOrders("damageSales");
      if (this.orderCheckbox) await this.getDataSearchOrders("damageOrders");
      if (this.serieCheckbox) await this.getDataSearchSeries();
      this.loadingSearch = false;
    },
    filterStatusChecklist(data, status) {
      if (data) {
        const tempData = Object.values(data).filter(cData => {
          if (cData.status) return cData.status === status;
        });
        return tempData.length;
      }
      return 0;
    },
    navigateToOrders() {
      this.$router.push({
        name: "pedidos-filter",
        params: {
          filter: "all"
        }
      });
    },
    goToOrdersByType(eventName) {
      if (eventName === "transfers")
        this.$router.push({
          name: "transfers"
        });
      else
        this.$router.push({
          name: "pedidos-filter",
          params: {
            filter: eventName
          }
        });
    },
    goToAnalytics() {
      this.$router.push({
        name: "analytics"
      });
    },
    searchOrder(orderNumber) {
      if (this.serieCheckbox) {
        this.$router.push({
          name: "searchBySerie",
          params: {
            seriesID: orderNumber
          }
        });
      } else {
        // :: Remove all white spaces from orderNumber
        orderNumber = orderNumber.replace(/_/g, "/");
        const noSpacesOrderNumber = orderNumber.split(" ").join("");
        this.$router.push({
          name: "search",
          params: {
            orderNumber: noSpacesOrderNumber,
            orderType: this.orderCheckbox ? "order" : "pedido"
          }
        });
      }
    },
    convertIdUppercase(id) {
      this.id = id.toUpperCase();
    },
    closeCalendar() {
      this.showCalendar = false;
      this.showDatesSelected = false;
      this.filterDateStatus = "Este mes";
      this.changeFilterDate("Este mes");
    },
    async changeFilterDate(value) {
      switch (value) {
        case "Rango de fechas": {
          this.showCalendar = true;
          this.showDatesSelected = true;
          break;
        }
        case "Hoy": {
          const startAt = `${moment().format("YYYY-MM-DD")}`;
          const endAt = `${moment()
            .add(1, "days")
            .format("YYYY-MM-DD")}`;
          this.getDashboardCounters(startAt, endAt);
          this.showDatesSelected = false;
          break;
        }
        case "Este mes": {
          const startAt = `${moment()
            .startOf("month")
            .format("YYYY-MM-DD")}`;
          const endAt = `${moment()
            .endOf("month")
            .format("YYYY-MM-DD")}`;
          this.getDashboardCounters(startAt, endAt);
          this.showDatesSelected = false;
          break;
        }
      }
    },
    searchByDatesCompleted() {
      const startAt =
        this.datesSelected[0] < this.datesSelected[1]
          ? this.datesSelected[0]
          : this.datesSelected[1];
      const endAt =
        this.datesSelected[1] > this.datesSelected[0]
          ? this.datesSelected[1]
          : this.datesSelected[0];
      this.getDashboardCounters(startAt, endAt);
      this.showCalendar = false;
    },
    resetDates() {
      this.datesSelected = [];
    }
  }
};
</script>
<style>
.dashboard__last-updated {
  text-transform: uppercase;
}
.headline {
  text-align: left;
}
.orders-title {
  font-size: 20pt;
}
.body-1 {
  font-weight: 300;
}
.background-gray {
  background: #f6f6f6 !important;
}
</style>
